export default __webpack_public_path__ + "static/media/upload_folder.8e8b3930.svg";